"use client"

// src/box.tsx
import { ui } from "@yamada-ui/core";
var Box = ui("div");
Box.displayName = "Box";
Box.__ui__ = "Box";

export {
  Box
};
//# sourceMappingURL=chunk-ZJJ7XTJB.mjs.map